<template>

<div class="form-inline">

	<select v-on:change="setDate" v-model="selected.year" class="form-control" @change="checkDisabledTo()" style="width:45%;">
		<option v-for="year in years">{{ year }}</option>
	</select>

	<select v-on:change="setDate" v-model="selected.month" class="form-control" style="width:45%;">
		<option v-for="month in months" :disabled="isMonthDisabled(month)">{{ month }}</option>
	</select>

</div>

</template>


<script>
    export default {
        props: {
	        type: {},
	        disabledTo: {
                default: null
            }
	    },
	    data: function() {

            return {
                selected: {

                	year: new Date().getFullYear(),
                	month: new Date().getMonth()+1,

                },

            }
        },
        created: function() {

            if (this.disabledTo) {
                this.selected.year = this.disabledTo.year()
            }

            if (this.disabledTo) {
                this.selected.month = (this.disabledTo.month() + 1)
            }

        	this.setDate();


        },
	    computed: {

	 		years: function() {

                var start = 1970
                if (this.disabledTo) {
                    start = this.disabledTo.year()
                }

                console.log('start')
                console.log(start)

	 			var end = 2050

	 			var years = {};

	 			while(start <= end) {

	 				years[start] = start;

	 				start++;
	 			}


	 			return years;

	 		},
	 		months: function() {

	 			var start = 1
	 			var end = 12

	 			var months = {};

	 			while(start <= end) {

	 				months[start] = start;

	 				start++;
	 			}


	 			return months;

	 		},
	 		formatedDate: function() {

	 			return this.selected.year+'-'+this.selected.month;

	 		}

	    },
	    methods: {

	    	setDate()
            {
	    		this.$emit('changed', this.formatedDate);
	    	},

            isMonthDisabled (month)
            {
                if (!this.disabledTo) {
                    return false
                }

                if (moment([this.selected.year, 0, 1]).month(month - 1).isBefore(this.disabledTo)) {
                    return true
                }

                return false
            },

            checkDisabledTo ()
            {
                if (!this.disabledTo) {
                    return
                }

                if (this.disabledTo.year() == this.selected.year && this.selected.month < (this.disabledTo.month() + 1)) {
                    this.selected.month = (this.disabledTo.month() + 1)
                    this.setDate()
                }
            }

	    }

    }
</script>
